<template>
  <v-layout
    align-center
    class="my-2"
    :column="$vuetify.breakpoint.xsOnly"
    :justify-end="$vuetify.breakpoint.smAndUp"
  >
    <v-flex
      v-if="incorrect || executed"
      order-xs1
      order-sm2
      shrink
    >
      <v-btn
        color="sz_violet"
        @click="close"
      >
        {{ $t('buttons.ok') }}
      </v-btn>
    </v-flex>
    <div
      v-else
      class="layout align-center justify-space-between"
    >
      <v-flex
        order-xs2
        order-sm1
        shrink
        :class="[$vuetify.breakpoint.xs ? 'mt-3' : 'mr-4']"
      >
        <a @click="close()">{{ $t('buttons.cancel') }}</a>
      </v-flex>
      <v-flex
        order-xs-1
        order-sm2
        shrink
      >
        <v-btn
          color="sz_violet"
          :disabled="executeLoader"
          :loading="executeLoader"
          @click="upload"
        >
          {{ $t('buttons.execute') }}
        </v-btn>
      </v-flex>
    </div>
  </v-layout>
</template>

<script>
export default {
    name: 'VerifyModalActions',
    props: {
        incorrect: {
            type: Boolean,
            required: true
        },
        executed: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        executeLoader () {
            return this.$store.getters['swrUpload/getExecuteLoader'];
        }
    },
    methods: {
        close () {
            if (this.executeLoader) return;
            this.$emit('close');
        },
        upload () {
            this.$emit('upload');
        }
    }
};
</script>
